import React, { useEffect, useState, useRef } from 'react';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: '¿Puedo empezar mañana?',
  answer: 'Sí. La lista de compras está en el checklist del protocolo. 12€ total en Mercadona. Esta noche puedes hacer el test patch y mañana empiezas la rutina completa.'
}, {
  question: '¿Los resultados están garantizados?',
  answer: 'Varían entre 20-40% según la consistencia y el tipo de piel. No son mágicos, son científicos. Si sigues el protocolo los 7 días, verás diferencia. Si no ves resultados el día 7, pide ajustes personalizados.'
}, {
  question: '¿Es seguro durante el embarazo o la menopausia?',
  answer: 'Consulta con tu médico antes de empezar. Los ingredientes son naturales, pero si estás embarazada o en tratamiento hormonal, es importante confirmarlo. Si tienes piel sensible, diluye el limón al 50%.'
}, {
  question: '¿Qué pasa si tengo rosácea?',
  answer: 'Haz el test patch obligatorio. Reduce la cantidad de aceite de oliva y usa el aloe vera como base principal. El protocolo tiene una variante adaptada para pieles reactivas incluida en el PDF.'
}, {
  question: '¿Cuánto duran los resultados?',
  answer: 'Con el mantenimiento (1× noche semanas 2-4), los resultados duran 3-6 meses. Luego repites el ciclo completo de 7 días cada 3 meses para mantener el colágeno activo.'
}, {
  question: '¿Se puede combinar con bótox?',
  answer: 'Espera 2 semanas después del tratamiento con bótox antes de empezar. Después es completamente compatible y potencia los resultados del bótox.'
}, {
  question: '¿Por qué funciona mejor que las cremas caras?',
  answer: 'Las cremas de superficie solo hidratan la epidermis. Los exosomas simulados de este protocolo usan liposomas naturales (aloe + miel) que penetran la barrera cutánea y llegan a la dermis donde está el colágeno.'
}, {
  question: '¿Funciona también para hombres de 40+?',
  answer: 'Sí, la piel masculina tiene las mismas necesidades de colágeno. Ajusta la cantidad de aceite de oliva si tienes piel grasa. El protocolo incluye notas de adaptación.'
}, {
  question: '¿Hay devoluciones?',
  answer: 'Al ser un producto digital, no hay reembolsos. Pero si el día 7 no ves resultados, escríbenos y te damos ajustes personalizados gratuitos para tu tipo de piel específico.'
}, {
  question: '¿Cómo recibo el protocolo?',
  answer: 'Descarga inmediata tras el pago. Recibes un enlace por email con el PDF completo (85 páginas), todos los checklists y las hojas de trabajo. Imprime los checklists para usarlos cada día.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.05
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section ref={sectionRef} className="py-20 px-4" style={{
    background: 'var(--color-cream)'
  }} data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-14" data-id="element-3">
          <h2 className="reveal font-playfair text-4xl md:text-5xl font-bold mb-4" style={{
          color: 'var(--color-dark)'
        }} data-id="element-4">
            Preguntas Frecuentes
          </h2>
          <p className="reveal reveal-delay-1 font-lato text-lg" style={{
          color: 'rgba(44, 24, 16, 0.6)'
        }} data-id="element-5">
            Resolvemos tus dudas antes de empezar
          </p>
        </div>

        <div className="space-y-3" data-id="element-6">
          {faqs.map((faq, index) => <div key={index} className="reveal rounded-2xl overflow-hidden transition-all duration-300" style={{
          background: openIndex === index ? 'var(--color-light)' : 'white',
          border: openIndex === index ? '1px solid rgba(212, 168, 83, 0.4)' : '1px solid rgba(44, 24, 16, 0.08)',
          boxShadow: openIndex === index ? '0 4px 20px rgba(212, 168, 83, 0.12)' : '0 1px 4px rgba(44, 24, 16, 0.04)'
        }} data-id="element-7">
              <button className="w-full flex items-center justify-between p-5 text-left transition-colors duration-200" onClick={() => toggle(index)} aria-expanded={openIndex === index} data-id="element-8">
                <span className="font-lato font-bold text-base pr-4" style={{
              color: 'var(--color-dark)'
            }} data-id="element-9">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-black transition-all duration-300" style={{
              background: openIndex === index ? 'var(--color-gold)' : 'rgba(212, 168, 83, 0.15)',
              color: openIndex === index ? 'var(--color-dark)' : 'var(--color-gold)',
              transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)'
            }} data-id="element-10">
                  +
                </span>
              </button>

              <div style={{
            maxHeight: openIndex === index ? '300px' : '0',
            overflow: 'hidden',
            transition: 'max-height 0.4s ease-out'
          }} data-id="element-11">
                <p className="font-lato text-sm leading-relaxed px-5 pb-5" style={{
              color: 'rgba(44, 24, 16, 0.75)'
            }} data-id="element-12">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}